import { CdkMenuModule, CdkMenuTrigger } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import {
    Component,
    computed,
    inject,
    model,
    OnInit,
    viewChild,
} from "@angular/core";
import dayjs from "dayjs";
import { toObservableSignal } from "ngxtension/to-observable-signal";
import { IconButton } from "../../../button/icon-button.component";
import { BaseConfig } from "../../../common/config/config.adapter";
import { TabOption, Tabs } from "../../../tabs/tabs.component";
import { CalendarService } from "../../calendar.service";
import { CalendarStore } from "../../calendar.store";
import { CalendarMode } from "../../calendar.types";
import {
    CalendarOutput,
    InputCalendar,
} from "../../../input/date/calendar/calendar.component";

@Component({
    selector: "app-calendar-header",
    templateUrl: "./calendar-header.component.html",
    standalone: true,
    imports: [IconButton, CommonModule, Tabs, CdkMenuModule, InputCalendar],
})
export class CalendarHeader extends BaseConfig implements OnInit {
    readonly store = inject(CalendarStore);
    readonly service = inject(CalendarService);

    menuTrigger = viewChild(CdkMenuTrigger);

    modes: TabOption[] = [
        {
            icon: "material-symbols:calendar-today-outline",
            label: "일",
            value: "day",
        },
        {
            icon: "material-symbols:calendar-view-week-outline",
            label: "주",
            value: "week",
        },
        {
            icon: "material-symbols:calendar-view-month-outline-sharp",
            label: "월",
            value: "month",
        },
    ];

    views: TabOption[] = [
        {
            icon: "majesticons:noteblock",
            label: "캘린더",
            value: "block",
        },
        {
            icon: "material-symbols:view-timeline",
            label: "타임라인",
            value: "timeline",
        },
    ];

    mode = model<CalendarMode>();
    _mode = toObservableSignal(this.mode);

    value = this.store.value;

    weekText = computed(() => {
        const day = dayjs(this.value());
        const startOfWeek = day.startOf("week").format("DD");
        const endOfWeek = day.endOf("week").format("DD");
        return `${startOfWeek}일 ~ ${endOfWeek}일`;
    });

    ngOnInit(): void {
        this._mode.subscribe((mode) => {
            if (mode) {
                this.store.setMode(mode!);
            }
        });
    }

    handleToday() {
        const today = new Date();
        this.store.setValue(today);
    }

    /**
     * @description 년도와 달을 이동하는 통합 함수
     * @param type
     * @param unit
     * @param number
     */
    handleNavigate(
        type: "prev" | "next",
        unit: "year" | "month" | "week" | "day",
        number: number,
    ) {
        if (!unit) {
            unit = this.store.mode()!;
        }

        if (type === "prev") {
            const value = dayjs(this.value()).subtract(number, unit).toDate();
            this.store.setValue(value);
        } else {
            const value = dayjs(this.value()).add(number, unit).toDate();
            this.store.setValue(value);
        }
    }
    /**
     * @param ev
     */
    handleEvent(ev: CalendarOutput) {
        this.store.setValue(ev.value!);
        this.menuTrigger()?.close();
    }

    /**
     * @description 일,주,월 중 선택한 모드에 따라 스토어에 저장
     * @param mode
     */
    handleModeChange(mode: any) {
        this.store.setMode(mode);
    }

    handleCreate() {
        this.service.handleCreate();
    }
}
